/**
 * ELT Quote Form — conditional logic (dependency-free).
 *
 * Behaviors:
 *  1. Conditional blocks: [data-elt-show-when="key"][data-elt-show-value="A|B"]
 *     show when the radio/select named contact[key] has a matching value.
 *     Inputs inside hidden blocks are disabled so they neither block HTML5
 *     validation nor submit values.
 *  2. ZIP-gated blocks: [data-elt-zip-prefixes="48,49"] show when the ZIP
 *     field value starts with one of the prefixes (Michigan install offer).
 *  3. Pickup checkbox [data-elt-pickup] makes the ZIP field optional.
 *  4. URL params:
 *       ?product=Handle  -> hidden [data-elt-param="product"] field
 *       ?type=cooler     -> checks the matching [data-elt-param-radio="type"] radio
 */
(function () {
  'use strict';

  function toggleBlock(block, show) {
    block.hidden = !show;
    var fields = block.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      fields[i].disabled = !show;
    }
  }

  function initForm(form) {
    var conditionals = form.querySelectorAll('[data-elt-show-when]');
    var zipBlocks = form.querySelectorAll('[data-elt-zip-prefixes]');
    var zipInput = form.querySelector('[data-elt-zip]');
    var pickup = form.querySelector('[data-elt-pickup]');
    var zipMarker = form.querySelector('[data-elt-zip-required-marker]');

    function currentValue(key) {
      var checked = form.querySelector('[name="contact[' + key + ']"]:checked');
      if (checked) return checked.value;
      var field = form.querySelector('select[name="contact[' + key + ']"], input[type="text"][name="contact[' + key + ']"], input[type="hidden"][name="contact[' + key + ']"]');
      return field ? field.value : '';
    }

    function updateConditionals() {
      for (var i = 0; i < conditionals.length; i++) {
        var block = conditionals[i];
        var key = block.getAttribute('data-elt-show-when');
        var values = (block.getAttribute('data-elt-show-value') || '').split('|');
        toggleBlock(block, values.indexOf(currentValue(key)) !== -1);
      }
    }

    function updateZipBlocks() {
      if (!zipInput) return;
      var zip = (zipInput.value || '').replace(/\s/g, '');
      for (var i = 0; i < zipBlocks.length; i++) {
        var block = zipBlocks[i];
        var prefixes = (block.getAttribute('data-elt-zip-prefixes') || '').split(',');
        var show = false;
        for (var j = 0; j < prefixes.length; j++) {
          var p = prefixes[j].trim();
          if (p && zip.indexOf(p) === 0) { show = true; break; }
        }
        toggleBlock(block, show);
      }
    }

    function updatePickup() {
      if (!pickup || !zipInput) return;
      zipInput.required = !pickup.checked;
      if (zipMarker) zipMarker.hidden = pickup.checked;
    }

    // URL params: hidden fields + radio preselects
    try {
      var params = new URLSearchParams(window.location.search);
      var paramFields = form.querySelectorAll('[data-elt-param]');
      for (var i = 0; i < paramFields.length; i++) {
        var name = paramFields[i].getAttribute('data-elt-param');
        var value = params.get(name);
        if (value) paramFields[i].value = value.slice(0, 250);
      }
      var paramRadios = form.querySelectorAll('[data-elt-param-radio]');
      for (var k = 0; k < paramRadios.length; k++) {
        var radio = paramRadios[k];
        var pv = params.get(radio.getAttribute('data-elt-param-radio'));
        if (pv && radio.value.toLowerCase().indexOf(pv.toLowerCase()) === 0) {
          radio.checked = true;
        }
      }
    } catch (e) { /* URLSearchParams unsupported — ignore */ }

    form.addEventListener('change', function () {
      updateConditionals();
      updateZipBlocks();
      updatePickup();
    });
    if (zipInput) zipInput.addEventListener('input', updateZipBlocks);

    updateConditionals();
    updateZipBlocks();
    updatePickup();

    // Bring the success message into view after a post-submit redirect.
    var success = form.querySelector('[data-elt-success]');
    if (success) {
      success.scrollIntoView({ block: 'center' });
      success.focus({ preventScroll: true });
    }
  }

  function init() {
    var forms = document.querySelectorAll('.elt-quote__form');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init inside the Shopify theme editor when the section reloads.
  document.addEventListener('shopify:section:load', function (event) {
    var forms = event.target.querySelectorAll('.elt-quote__form');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
  });
})();
